export default {
  'portal.renderTemplate.noUrlProvided': 'No se proporcionó una URL de plantilla.',
  'portal.renderTemplate.notFound': 'No se encontró la plantilla solicitada.',
  'portal.renderTemplate.renderError': 'No se pudo renderizar la plantilla.',
  'portal.renderTemplate.renderErrorTrace': 'Referencia de error:',
};
